module.exports = __webpack_public_path__ + "static/media/icon-cookies.82e0523a.svg";